import { render, staticRenderFns } from "./AccessUsers.vue?vue&type=template&id=435820b6&"
import script from "./AccessUsers.vue?vue&type=script&lang=js&"
export * from "./AccessUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('435820b6')) {
      api.createRecord('435820b6', component.options)
    } else {
      api.reload('435820b6', component.options)
    }
    module.hot.accept("./AccessUsers.vue?vue&type=template&id=435820b6&", function () {
      api.rerender('435820b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/AccessUsers.vue"
export default component.exports